
    import I18n from 'i18nObj';
    
      import 'translations/collaborations.collaborator_picker';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('collaborations.collaborator_picker');
  